import {Pipe} from "@angular/core";
import {intTruncateEllipsis} from "../../utils";

@Pipe({
  name: 'intTextClamp',
  pure: false
})
export class IntTextClampPipe {
  transform(value: string, maxCharsAmount: number = 100, showAll: boolean = true): string {
    return intTruncateEllipsis(value, maxCharsAmount, showAll) || '';
  }
}
